import colors from 'style-utils/colors';
import media from 'style-utils/media-queries';
import styled from 'styled-components';

export const VerifySubtitleOtp = styled.h2`
  margin: 0 0 32px;
  font-size: 14px;
  line-height: 18px;
  color: ${colors.blackTwelve};
  font-weight: 400;

  ${media.tablet`
    margin-top: 8px;
  `}
`;
